/* eslint-disable max-len */
import { EventsEntity } from './models/events-entity';

export const EVENTS: EventsEntity[] = [
  {
    id: 'Mock-1',
    meetupId: 'fkbrhsyccgbkc',
    youtubeId: 'hUEDYtzS4Zs',
    title: 'Main',
    date: '04/27/21',
    speaker1: 'Yvonne Allen | Angular GDE and Co-Organizer of @gdgatl',
    description1:
      'Deep Sea Dive into angular.json: Get your aquatic gear and come along with me as we explore the sea of the Angular Workspace File (angular.json) from sandbar to abyss. In this talk we will be discussing all the configuration options available to you since the Angular 11 release.',
    speaker2: 'Aaron Frost | ng-conf, XTLS, & HeroDevs',
    description2:
      'Angular community prepare yourself for a once-in-a-lifetime talk about an undisclosed subject.',
    speaker3: 'Chris Snow | Software Engineer',
    description3:
      'Visually Teaching RxJS SwitchMap, MergeMap, ConcatMap, & ExhaustMap ⚡',
    series: 'americas-en',
  },
  {
    id: 'Mock-2',
    meetupId: 'fkbrhsycchbhc',
    youtubeId: 'Zs-d6_FPfMY',
    title: 'Main',
    date: '05/25/21',
    speaker2: 'Mike Hartington | Senior Developer at Ionic',
    description2:
      'Building an app today means that it needs to be available on the web, iOS and Android. For many, this can seem like a daunting task given the different tools, languages, and knowledge needed to be proficient in each platform. But it doesn’t have to be. Enter Capacitor. Capacitor is a new approach to building apps for multiple platforms. Starting with a strong emphasis on “web first”, Capacitor provides tools and APIs needed to make amazing apps for the Web, but also for native iOS and native Android. In this talk, we/ll look at how use Capacitor in your projects and take your existing web app, and deploy it to native mobile.',
    speaker1:
      'Mike Ryan | Software Architect at Synapse Wireless & co-creator of NgRx',
    description1:
      'Getting Visual with Reactive Charts in Angular | For years I was struck with fear whenever a requirement asked me to implement a chart. What charting library would I use? Would the one I select be maintained? What if I couldn’t find one that had all of the features I needed? Then one day I decided to overcome my fear and try building a visualization without a library. It turns out Angular and the Material CDK make it far easier than I could have imagined. Learn how to build fully responsive & reactive charts using just Angular, Material, and RxJS.',
    speaker3: 'Jay Bell | Trellis',
    description3: 'Why & How to Use Auxiliary Routes ⚡',
    series: 'americas-en',
  },
  {
    id: 'Mock-2.5',
    meetupId: 'rmjgjsyccjbtb',
    youtubeId: 'ey0hPZ4CuZ4',
    title: 'Main',
    date: '06/15/21',
    speaker1: 'Brian Love | Principal Architect at LiveLoveApp',
    description1:
      'Angular Template Type Checking | Angular provides three distinct template type checking modes that enable you, your team, and your organization to ensure that your application and its templates are error-free. Introduced as one of the core features of the new Ivy compilation and rendering pipeline, template type checking goes further than ever to enforce strict type checking of embedded views, input and output bindings, event emitters, and more. In this talk, you’ll learn how to configure each mode and what level of template type checking is provided in each mode.',
    speaker2: 'Michael Madsen | Lead Technologist at Inmoment',
    description2:
      'NCC-1701 Angular on the Enterprise | Have you ever wondered how Angular is used efficiently in enterprise teams? If so, look no further! Come and see some solid strategies for modularizing code for cleaner builds, externalizing the environment for versatile builds, and some cool tricks with the nrwl/nx monorepo.',
    speaker3: 'Duncan Faulkner | Developer at AST',
    description3: 'Angular Flex-Layout ⚡',
    series: 'europe-africa-en',
  },
  {
    id: 'Mock-3',
    meetupId: 'qmbrhsyccjbdc',
    title: 'Main',
    date: '06/22/21',
    speaker1:
      'Bram (Beeman) Borggreve | Sr. Technical Advisor at Kin Foundation, Founder of @AngularDiscord',
    description1:
      'The 5 Steps to Adding an In-App Economy to Angular | In this talk I will show how easy it is to integrate Kin in your Angular application. We will go over the basics of Kin, what it is and how it works under the hood. The best thing is, you don’t need to understand this to successfully add Kin to your app.',
    speaker2:
      'Alyssa Nicoll | Angular Developer Advocate for Kendo UI & GDE for Angular',
    description2:
      'Tour of Heroes Remodel Challenge | In 30 minutes, Alyssa will take you on a dive into the Tour of Heroes (originally written by John Papa) and give the UI a facelift. The top two best-looking remodels win a 50$ Amazon gift card! During the challenge time, Alyssa will pull down the TOH, give a quick overview of the app, include SASS, and start remodeling. Compete in the challenge or sit back and learn some CSS tricks - whichever you choose!',
    speaker3:
      'Martine Dowden | CTO / UX Designer & Developer at Andromeda Galactic Solutions',
    description3:
      'Tables Have Their Place: Now Let’s Make Them Fit ⚡ | Tables have gotten a bad reputation over the years. Historically, we used them for layout, a practice thoroughly frowned upon today. When responsive and fluid layouts came into the scene, they proved difficult to work with. As a result, we have shied away from them but it doesn’t have to be this way. In this talk we will go over choosing if a table is appropriate and then how to create a responsive table that can work with both desktop and mobile UIs.',
    series: 'americas-en',
  },
  {
    id: 'Mock-3.5',
    meetupId: 'rmjgjsycckbbc',
    title: 'Main',
    date: '07/20/21',
    speaker1:
      'Manfred Steyer | Trainer, Consultant, Programming Architect at ANGULARarchitects',
    description1:
      'The Micro Frontend Revolution: Using Webpack 5 Module Federation with Angular | The implementation of micro frontends has so far been anything but easy. Since common frameworks and build tools didn’t even know this idea, you had to dig into the tricks bag.  Module Federation offered by Webpack 5 initiates a crucial change of direction here. It allows you to load separately compiled applications at runtime and to share libraries between them.  In this session, you learn how to use this mechanism to create micro frontends with Angular. Besides the default scenarios, we also look into dynamic Module Federation, sharing libraries, and dealing with version mismatches.  At the end of the session, you know how to use Module Federation in your projects and what the consequences are.  Trainer, consultant and programming architect with focus on Angular. Google Developer Expert (GDE) and Trusted Collaborator in the Angular team who writes for O’Reilly, the German Java Magazine, and Windows developer. Regularly speaks at conferences.',
    speaker2: 'Michael Dowden | Founder & CEO at Andromeda Galactic Solutions',
    description2:
      'ZAP! API Integrations with Zapier | Learn from real-world examples how to quickly build automation & 3rd party API integrations using cloud platforms like Zapier. Will use the Tech Daily CFP service as an example.',
    series: 'europe-africa-en',
    // headshotUrl: 'https://angulararchitects.io/wp-content/uploads/2019/10/steyer-web-500x500.jpg'
  },
  {
    id: 'Mock-4',
    meetupId: 'qmbrhsycckbkc',
    title: 'Main',
    date: '07/27/21',
    speaker1: 'John Papa',
    description1:
      'Control Your Data’s Flow with HTTP Interceptors | Your app has its own data challenges. Early on you realize you need headers for all HTTP requests, you need to transform responses, and you want a busy indicator to wait for all requests to complete. The time to own and control your data flow is now. Fortunately Angular provides the right tool for this job in HTTP Interceptors with the HttpClient module. But this problem isn’t unique to Angular. How do React, Vue and Svelte developers approach these challenges? Do we even need HttpClient for Angular? Learn how you can take control of your Angular app’s data flow by designing your HTTP Interceptors.',
    speaker2: 'Doguhan Uluca',
    description2:
      'Minimal MEAN: Full-Stack TypeScript | It can be daunting to ship your code on the web and more so to pick the right stack to deliver your idea to the cloud. However, if you don’t ship it, it never happened. Using TypeScript with Mongo, Express, Angular, and Node you can deliver solutions without digging yourself into a hole using unnecessary abstractions. My easy to learn and use template project ’Minimal MEAN’ will get you started and deployed on the cloud over a long weekend, using Docker, DocumentTS, GitHub and CircleCI to the cloud of your choice.',
    speaker3: 'Armela Gjoka',
    description3: 'A Short Trip Into Form Validation ⚡',
    series: 'americas-en',
  },
  {
    id: 'Mock-4.5',
    meetupId: 'rmjgjsycclbwb',
    title: 'Main',
    date: '08/17/21',
    speaker1:
      'Martine Dowden | CTO / UX Designer & Developer at Andromeda Galactic Solutions',
    description1:
      'Can You Read Me Now | 15% of the world’s population has some form of disability, but only very few of our websites are actually accessible. But what does that word mean anyway? Accessible?  In this talk we will go over what accessibility means in the context of web content and how to get your team started in making sure your content can be accessed by all.',
    speaker2: 'Maria Korneeva | Frontend Technology Lead at Aleri Solutions',
    description2:
      'Frontend technology radar - A technology is a living document to assess and structure existing and nascent languages, frameworks, tools, patterns and platforms. As such, it provides an overview and a platform to share knowledge and experience in technologies, to reflect on technology decisions and continuously evolve the technology landscape of the company. Maria is going to introduce this tool and to place some frontend technologies on the radar. This talk is highly opinionated and will strive from your active participation and discussion.',
    speaker3: 'Speaker C',
    description3: 'TBA ⚡',
    series: 'europe-africa-en',
  },
  {
    id: 'Mock-5',
    meetupId: 'jxgshsycclbgc',
    title: 'Main',
    date: '08/24/21',
    speaker1:
      'Jan-Niklas Wortmann | Enterprise Consultant at Evora IT Solutions Inc',
    description1:
      'A Practical Guide to Testing Observables | Hands down, testing Observables is hard. Even though RxJS comes with marble testing, that does not necessarily make it easier.  In this talk you will learn very practical methods to test your RxJS code in an efficient and sustainable way and in the end, you probably don’t even need marble testing.',
    speaker2: 'Mike Brocchi | HeroDevs',
    description2:
      'Angular Schematics | Schematics is a library that powers a few commands in the Angular CLI including "new", "generate" and "update". Come learn the basics of how they work and how you can utilize them in your projects, even if you don\'t write your own. Come learn about the possibilities and bring your questions!',
    speaker3: 'Alisa Duncan',
    description3:
      'Tidy Up Your Tests ⚡ | Use Component Harnesses to Write Tests that Bring You Joy',
    series: 'americas-en',
  },
  {
    id: 'Mock-5.5',
    meetupId: 'rmjgjsyccmbcc',
    title: 'Main',
    date: '09/21/21',
    speaker1: 'Maxim Salnikov | Developer Engagement Lead at Microsoft',
    description1:
      'Sending the Angular App Into Deep, Deep Offline With Workbox | There is no need to advocate for progressive web apps anymore. The idea of connection-independent applications has proven its viability and we see more and more large and small projects following that path, making the offline-ready behavior a best practice, good manner of the web. In my session, based on the deep exploration of Service Worker API possibilities and gathered UX gotchas, we go through the history of the offline web, the importance of treating the network as an enhancement, current challenges (and their solutions) and proper tooling. We architect our offline-ready Angular app applying the best tech and UX practices adding the features one-by-one: app shell, caching resources and data, sync when online. All in name of our users who demand the new level of the resilient web experience.',
    speaker2: 'Lars Gyrup Brink Nielsen',
    description2:
      'Confidence in templates and styles with Angular Ivy | We learn how to reason about style binding evaluation through style binding precedence rules with simple examples sprinkled with a few style binding caveats. We end this topic by reviewing a demo application to visualize Angular Ivys style evaluation. After that, we learn how to enable and configure strict template type checking. We see examples of all violations and how they appear inline in our code editor as well as during compilation. Finally, we learn how to use strict template type checks with the AsyncPipe.',
    speaker3: '',
    description3: '',
    series: 'europe-africa-en',
  },
  {
    id: 'Mock-6',
    meetupId: 'jxgshsyccmblc',
    title: 'Main',
    date: '09/28/21',
    speaker1:
      'Patricio Vargas | Sr. Developer Advocate at OneSignal, GDE Angular and Web Tech, Twilio Champion, MDE Cloudinary, Auth0 Ambassador, Postman Supernova, Google Women Techmaker',
    description1:
      'User Engagement in Angular | In a digital era, engaging with the users of your application is very important. Engaging with your users will not only increase the UX, it will increase user retention. In this talk, I will show you how to engage with your users using Push Notifications. ',
    speaker2: 'Nathan Walker and NStudio Team ',
    description2: `A Platform Celebration with NativeScript | NativeScript has been around since 2014 and remains a powerhouse for productivity albeit an often misunderstood technology. Most know it as 'just another cross platform framework'. Let's discuss the perceptions that exist today and how the core competency of NativeScript is unparalleled and unwavering as it stands up straight amidst a very noisy technology space. We can explore how it's used today, what else it could be used for in the future and lastly how it's celebration of platform APIs is important for maintenance and scalability.`,
    series: 'americas-en',
  },
  {
    id: 'Mock-7',
    meetupId: 'jxgshsyccnbjc',
    title: 'Main',
    date: '10/26/21',
    speaker1: 'Joe Eames | Principal at Herodevs, Programmer, Educator',
    description1: 'A Concrete Reason to use Abstract Types | more info tba',
    speaker2: 'Chau Tran | Senior Software Engineer at Nrwl',
    description2:
      'You can Slice NgRx?! | In this talk, the audience will learn about what Slice means in the Redux context. In addition, we will also learn how we can utilize the Slice concept with NgRx, via a livecode session',
    series: 'americas-en',
  },
  {
    id: 'Mock-7.5',
    meetupId: 'rmjgjsyccpbvb',
    title: 'Main',
    date: '11/16/21',
    speaker1:
      'Katerina Skroumpelou | Software Engineer at Nrwl, Nx core team, GDE for Angular/Web Technologies/Google Maps platform.',
    description1:
      'You’re already using the Angular CLI to architect and build your apps. In this presentation, we’ll see the benefits of using Nx, not only as a CLI tool, but also as an ecosystem where your app can grow.',
    speaker2:
      'Alain Chuatard | Google Developer Expert in Web Technologies, Angular, and Google Maps.',
    description2:
      'Angular modules have been part of the framework since the very first versions of Angular JS. In this talk, we’ll go back in history and take a look at why ng-modules came to be, how they have been helping us so far, and why there are discussions to get rid of them in the future. We will also explain what is the actual purpose of NgModules in modern Angular and cover the most common misconceptions about them.',
    speaker3: '',
    description3: '',
    series: 'europe-africa-en',
  },
  {
    id: 'Mock-8',
    meetupId: 'jxgshsyccpbfc',
    title: 'Main',
    date: '11/23/21',
    speaker1: 'Venkata Keerti Kotaru',
    description1: 'TBA',
    speaker2: 'Mark Whitfeld',
    description2: 'TBA',
    series: 'americas-en',
  },
  {
    id: 'Mock-8.5',
    meetupId: 'rmjgjsyccpbvb',
    title: 'Main',
    date: '12/14/21',
    speaker1: 'Lars Gyrup Brink Nielsen',
    description1:
      'Lars introduces GitHub Actions and GitHub action workflows and answers the following questions. What can GitHub workflows automate? What can trigger GitHub action workflows? Which types of GitHub Actions can we pick from when implementing our own that are either project-specific or published on GitHub Marketplace? Finally, a CI workflow for an Angular project is demonstrated.',
    speaker2: 'Ana Cidre',
    description2: 'TBC',
    speaker3: '',
    description3: '',
    series: 'europe-africa-en',
  },
  {
    id: 'Mock-9.5',
    meetupId: 'rmjgjsydccbxb',
    title: 'Main',
    date: '01/18/22',
    speaker1: 'Rainer Hahnekamp | Trainer & Consultant AngularArchitects.io',
    description1: 'RxJS 7 - One Share to Rule them all (Deep Dive)',
    speaker2: 'Bonnie Brennan | Angular GDE, Founder of Angular Nation',
    description2: 'Angular Dynamic Rendering Options.',
    speaker3: 'Jessica Janiuk | Software Engineer, Google, Angular Core Team',
    description3: 'The State of Angular',
    series: 'europe-africa-en',
  },
  {
    id: 'Mock-9',
    meetupId: 'jxgshsydccbhc',
    youtubeId: 'QuH2pUBeNJ4',
    title: 'Main',
    date: '01/25/22',
    speaker1: 'Ankita Sood | Engineer @ Dell SecureWorks',
    description1: 'Host-Context() and It’s Uses ⚡',
    speaker2:
      'Alain Chautard | GDE in Angular, International Speaker, GDG Sacramento Organizer',
    description2: 'The life and (possible) disappearance of ng-module',
    series: 'americas-en',
  },
  {
    id: 'Mock-10.5',
    meetupId: 'rmjgjsydcdbtb',
    title: 'Main',
    date: '02/15/22',
    speaker1:
      'Lars Gyrup Brink Nielsen - Writer, Speaker, FOSS Maintainer, MVP Github star and Author',
    description1:
      'Lars introduces GitHub Actions and GitHub action workflows and answers the following questions. What can GitHub workflows automate? What can trigger GitHub action workflows? Which types of GitHub Actions can we pick from when implementing our own that are either project-specific or published on GitHub Marketplace? Finally, a CI workflow for an Angular project is demonstrated.',
    speaker2:
      'Duncan Faulkner - Angular developer, Blogger, Speaker, OSS Enthusiast',
    description2:
      'An introduction into the Angular Material Form Field component, a high level overview of the options available and how to use them.',
    series: 'europe-africa-en',
  },
  {
    id: 'Mock-10',
    meetupId: 'jxgshsydcdbdc',
    youtubeId: 'dTZMmfdMcNA',
    title: 'Main',
    date: '02/22/22',
    speaker1: 'Keerti Kotaru | Principal Architect at Cognizant',
    description1: 'PWA Cookbook (Progressive Web Apps) ⚡',
    speaker2: 'Muhammad Awais | Full Stack Developer at @thrashtechinfo',
    description2:
      'Dynamic Component Creation Redefined with Angular Ivy | Ivy also enables quality of life improvements to the way developers can dynamically create components. The API has now been simplified. Before the changes in Angular v13, dynamically creating components required a lot of boilerplate code.',
    speaker3: 'Owen Mecham | Technical Product Manager at ADESA',
    description3:
      'MicroFrontends and Module Federation in Angular | Are you tired of coordinating deployments with multiple teams? Would you like to be able to ship code at any time without disrupting your users? Would you like to be able to share solutions in multiple applications even if they don’t use Angular? Micro Frontends may be the solution you’re looking for. We’ll discuss MicroFrontends via Web Components and Module Federation',
    series: 'americas-en',
  },
  {
    id: 'Mock-11.5',
    meetupId: 'rmjgjsydcfbtb',
    youtubeId: 'Co3QeUBLAg0',
    title: 'Main',
    date: '03/15/22',
    speaker1:
      'Aristeidis Bampakos - Aristeidis is an Angular GDE | Team Lead @Plex-Earth.',
    description1:
      'Testing components with Angular CDK - Whether you are using the Angular Material library or building a 3rd party component library by yourself, Angular CDK provides all the necessary infrastructure to help you test your components. In this talk, we will learn about the Angular CDK component harness, a mechanism that enables you to write robust, readable, and concise tests for your Angular components.',
    speaker2:
      'Jay Cooper Bell - Jay is an Angular GDE and CTO/Co-Founder @Social Enterprise.',
    description2:
      'Running Angular Service layer in Web Workers - We will walk through the process of bootstrapping an Angular application within a Web Worker while communicating between multiple Web Workers and the main Angular app (main thread w/ DOM) using Broadcast channel.',
    speaker3:
      'Lars Gyrup Brink Nielsen - Lars is a Tech Speaker, Tech Writer, FOSS Maintainer, and Microsoft MVP.',
    description3:
      'GitHub Actions and workflows Abstract: Lars introduces GitHub Actions and GitHub action workflows and answers the following questions. What can GitHub workflows automate? What can trigger GitHub action workflows? Which types of GitHub Actions can we pick from when implementing our own that are either project-specific or published on GitHub Marketplace? Finally, a CI workflow for an Angular project is demonstrated.',
    series: 'europe-africa-en',
  },

  {
    id: 'Mock-12.5',
    meetupId: 'scvjtsydcgbzb',
    youtubeId: 'cq08bFUrNAA',
    title: 'Main',
    date: '05/17/22',
    speaker1: 'Mini Bhati',
    description1: 'Dependency Injection',
    speaker2: 'Jeffry Houser | Lead UI Software Engineer at Disney Streaming',
    description2: 'Optimizing Angular Components for Reuse',
    speaker3: 'Colum Ferry | Senior Software Engineer at Nrwl',
    description3:
      'Module Federation vs Micro Frontends: What do you actually need?',
    series: 'europe-africa-en',
  },

  {
    id: 'Mock-11',
    meetupId: 'jxgshsydcfbdc',
    youtubeId: 'OPW6MJoPnPY',
    title: 'Main',
    date: '05/24/22',
    speaker1: 'Cecelia Martinez | Community Lead at Replay.io',
    description1: 'Debugging Angular Applications',
    speaker2: 'Michael Dowden | CEO at Andromeda Galactic Solutions',
    description2: 'Hosted, Not Served',
    series: 'americas-en',
  },

  {
    id: 'Mock-13',
    meetupId: 'zwcltsydcjbcc',
    youtubeId: 'R0scVA-PsnI',
    title: 'Main',
    date: '06/14/22',
    speaker1:
      'Karsten Silz | Full-stack Java Developer | Contractor | InfoQ Java editor, speaker, and co-founder of "Your Home in Good Hands"',
    description1:
      "Google's Flutter: Mobile, Web & Desktop Front-Ends from 1 Codebase",
    speaker2:
      'Felix Lemke | Sr Software Engineer @ InterfaceWerk | Coding coach | RxJS/NgRX contributor',
    description2: 'Angular Forms On A Ride Through the Router',
    speaker3:
      'Younes Jaaidi | Software Development Cook, Teacher & Coach | Google Developer Expert for Angular & Web Technologies',
    description3: 'Keep your tests healthy with DOM distancing',
    series: 'europe-africa-en',
  },

  {
    id: 'Mock-13.5',
    meetupId: 'dxcltsydcjblc',
    youtubeId: '5M0RAV3TvW8',
    title: 'Main',
    date: '06/28/22',
    speaker1:
      'Gleb Bahmutov | JavaScript Ninja | Image Processing Expert | Software Quality Fanatic | Sr Director of Engineering @ Mercari',
    description1: 'HTTP/1, HTTP/2, HTTP/3, HTTP/∞',
    speaker2:
      'Jordan Powell | DX Engineer @ Cypress | Co-Founder of Dream On: Global, Christian, Husband, Father, Musician & Cleveland Sports Fan',
    description2: 'Multi-Domain (origin) Testing in Cypress',
    speaker3:
      'Carl Bergenhem | Principal Product Manager @ KendoUI | Web developer | speaker | fitness enthusiast | metalhead | video game aficionado.',
    description3: 'Developing a Product Sense',
    series: 'americas-en',
  },

  {
    id: 'Mock-14',
    meetupId: 'zwcltsydcjbcc',
    youtubeId: 'E9RDS7lcQns',
    title: 'Main',
    date: '07/12/22',
    speaker1: 'LIGHTNING TALKS LOLLAPALOOZA',
    description1:
      'Come give a jolt to your dev skills with an afternoon of electifying presentations at the Lightning Talks Lollapalooza!',
    speaker2: '',
    description2: '11 am - 1 pm MT',
    speaker3: '',
    description3:
      'Topics Include: ng-deep, NgRx Action Group Creator, Design Principles, Dependency Injection, Standalone PDC, Reactive Forms, & MORE!',
    series: 'europe-africa-en',
  },

  {
    id: 'Mock-14.5',
    meetupId: 'dxcltsydcjblc',
    youtubeId: '8aeQgua21gg',
    title: 'Main',
    date: '07/26/22',
    speaker1:
      'Varun Vachhar | DX Engineer @ Chromatic | Contributor to Storybook',
    description1: 'Testing Component Interactions with Storybook',
    speaker2: 'Craig Shearer | Full-Stack Architect & Developer',
    description2: 'Super-Productive Angular Forms with Formly',
    speaker3: 'Chau Tran | Senior Engineer @ Nrwl',
    description3: 'Declarative THREE.js in Angular',
    series: 'americas-en',
  },
  {
    id: 'Mock-15',
    meetupId: 'fxcltsydclbfc',
    youtubeId: 'ymg_6XBWFQE',
    title: 'Main',
    date: '08/23/22',
    speaker1: 'COUNTDOWN TO ng-conf PARTY!!',
    description1: `Come help us countdown to the return of the biggest Angular conference of the year as we party with some of the speakers from ng-conf 2022!

      Join Deborah Kurata, Erik Slack, Kate Sky, Craig Spence, Alisa Duncan, Preston Lamb, & Jordan Powell for a night of Angular trivia, great conversation, learning, prizes, & FUN! 🎉`,
    speaker2: '',
    description2: '6pm - 7:30pm MT',
    speaker3: 'Dan & Valentin | Innovint',
    description3: 'The Business Case for Using PWAs',
    series: 'europe-africa-en',
  },

  {
    id: 'Mock-16',
    meetupId: 'fxcltsydcmbkc',
    youtubeId: 'ZmBehBLZWw8',
    title: 'Main',
    date: '09/27/22',
    speaker1: 'Simon McEnlly | COO at WallabyJS',
    description1:
      'Is Your JavaScript / TypeScript Testing Stack Holding You Back?',
    speaker2:
      'Duncan Hunter | Author on Pluralsight & Lead Frontend Engineer for zware.com.au',
    description2: 'Building Angular Apps with Web Components and Design Tokens',
    series: 'americas-en',
  },
  {
    id: 'Mock-16.5',
    meetupId: '288500237',
    youtubeId: 'Ao33tIwqy6Y',
    title: 'Main',
    date: '10/11/22',
    speaker1:
      'Eduardo Roth | Hero Software Engineer at HeroDevs | Ionic Developer Expert',
    description1: 'Pensando de manera Reactiva... en familia!',
    speaker2: 'Rafael Mestre | Senior Software Engineer at HeroDevs',
    description2:
      'Simplifica tus formularios en Angular usando inyección de dependencias',
    speaker3: 'Alfredo Perez | Staff UI Engineer at SailPoint',
    description3: 'Mejora tu DevX con Cypress y StoryBook',
    series: 'americas-en',
  },
  {
    id: 'Mock-17',
    meetupId: 'fxcltsydcnbhc',
    youtubeId: 'h2p0tjOfNd8',
    title: 'Main',
    date: '10/25/22',
    speaker1: '',
    description1: `Whether you're currently looking for a job or plan to at ANY point in your career (ahem, ALL of us), you will NOT want to miss this month's special Angular Community Meetup event!
    This month's Meetup is all about helping YOU with the ins and outs of finding and securing a new job as a programmer! We're pleased to welcome Software Technology Group (STG), leading industry experts and technology partners, as our panelists for the discussion.
    Joining STG will be James Spivey, Director of Engineering at Cisco, who will add to the discussion with his extensive experience from the perspective of a hiring manager.
    Let's go get you your next amazing opportunity!`,
    speaker2: '',
    description2: '11 am - 1 pm MT',
    series: 'americas-en',
  },
  {
    id: 'Mock-17.5',
    meetupId: '289312597',
    title: 'Main',
    date: '11/08/22',
    speaker1:
      'Eduardo Roth | Hero Software Engineer at HeroDevs | Ionic Developer Expert',
    description1: 'Ionic y Capacitor, ¿qué puedo hacer con ellos?    ',
    speaker2:
      'Alejandro Cuba Ruiz | Principal Front End Engineer @ World Fuel Services',
    description2:
      'Patrones útiles en el desarrollo de aplicaciones para navegadores web',
    speaker3: 'Aaron Frost | CEO @ HeroDevs - ngConf Organizer',
    description3:
      '¿Qué debo saber si quiero trabajar en USA si vivo en un país hispano?',
    series: 'americas-en',
  },
  {
    id: 'Mock-18',
    meetupId: '289648987',
    title: 'Main',
    date: '12/06/22',
    time: '6:00 - 7:30 pm MST',
    speaker1:
      'Lightning Talk by Chau Tran | Angular Templates with Dependency Injection',
    description1: '',
    speaker2:
      "Discussion Panel With Ward Bell, Minko Gechev, Liz Saling & Lara Newsom | The Do's & Don'ts On the Job As A Programmer",
    description2: '',
    speaker3: '',
    description3: '',
    series: 'americas-en',
  },
  {
    id: 'Mock-19',
    meetupId: 'fxcltsyfccbgc',
    title: 'Main',
    date: '01/24/23',
    time: '6:00 - 7:30 pm MST',
    speaker1:
      'Josh Morony | GDE | Software Engineer | Author | Content Creator',
    description1: 'Thinking Reactively in Angular',
    speaker2: 'Zach Gardner | Senior Consultant, Keyhole Software',
    description2: 'Intro to SignalR, Integrating with Avaya Agent for Desktop',
    speaker3: 'Stephen Cooper',
    description3: 'Fireside Chat',
    series: 'americas-en',
  },
  {
    id: 'Mock-19.5',
    meetupId: '290446226',
    title: 'Main',
    date: '01/10/23',
    time: '11:00 - 1:00 am MST',
    speaker1: 'Juan Angustia | Senior UX en Google Meet',
    description1:
      'Interacciones entre los desarrolladores fronted y los diseñadores UX',
    speaker2: 'Ricardo Chavarría | Software Engineer Angular en DevIntent',
    description2:
      'Un enfoque empresarial para el patrón de componentes Smart and Dumb en Angular',
    speaker3: '',
    description3: '',
    series: 'americas-en',
  },
  {
    id: 'Mock-20.5',
    meetupId: '290446226',
    youtubeId: 'i7Vo5eeIGOQ',
    title: 'Main',
    date: '02/14/23',
    time: '11:00 - 1:00 am MST',
    speaker1: 'Mayra A. Rodriguez',
    description1: 'Creando aplicaciones fullstack con Nx',
    speaker2: 'Christian Sánchez',
    description2: 'Autenticación con Auth0 y Angular',
    speaker3: '',
    description3: '',
    series: 'americas-en',
  },
  {
    id: 'Mock-21',
    meetupId: '291343829',
    youtubeId: '',
    title: 'Main',
    date: '02/21/23',
    time: '6:00 - 8:00 pm MST',
    speaker1: 'Virtual Job Fair',
    description1:
      'Update your resume and LinkedIn profile, be prepared to connect with representatives from some shining companies in the industry, and come land your next great job!',
    speaker2: '',
    description2: '',
    speaker3: '',
    description3: '',
    series: 'americas-en',
  },
  {
    id: 'Mock-22',
    meetupId: 'fxcltsyfcdblc',
    youtubeId: '-ArDAc2VZM0',
    title: 'Main',
    date: '02/28/23',
    time: '6:00 - 7:30 pm MST',
    speaker1: 'Quantarius Ray',
    description1:
      'Cypress Component Testing with Angular Standalone Components.',
    speaker2: 'Colum Ferry',
    description2: 'Dev Chat Interview',
    speaker3: 'Alisa Duncan',
    description3: 'Angular Component Test Harnesses FTW',
    series: 'americas-en',
  },
  {
    id: 'Mock-23',
    meetupId: '291693767',
    youtubeId: 'TwGNdpExfpo',
    title: 'Main',
    date: '03/14/23',
    time: '11:00 - 2:00 pm MST',
    speaker1: 'Patricio V',
    description1: 'Angular y Tailwind, ¡el dúo dinámico!',
    speaker2: 'Aileen Villanueva Lecuona',
    description2: 'Machine Learning con Tensorflow.js',

    series: 'americas-en',
  },
  {
    id: 'Mock-24',
    meetupId: 'fxcltsyfcfblc',
    youtubeId: 'XHB-ZJbR01w',
    title: 'Main',
    date: '03/28/23',
    time: '11:00 am - 12:30 pm MST',
    speaker1: 'Colum Ferry',
    description1:
      'Harnessing the Power of Nx to Enhance Your Angular Development',
    speaker2: 'Emma Twersky',
    description2: 'The State of Angular',
    speaker3: 'Ady Ngom',
    description3: 'The Dev Life: Accepting Change',
    speaker4: 'Rob Ocel',
    description4: 'The Dev Life: Building A Winning Team Culture',
    series: 'americas-en',
  },
  {
    id: 'Mock-25',
    meetupId: '292321853',
    youtubeId: 'TfWOBt0hmDE',
    title: 'Main',
    date: '04/11/23',
    time: '12:00 pm - 01:30 pm MST',
    speaker1: 'Nelson Gutierrez',
    description1: 'Scully: Acelera al máximo tu aplicación Angular',
    speaker2: 'Giovanni Rivas',
    description2: 'AWS Serverless y Angular',
    series: 'americas-en',
  },
  {
    id: 'Mock-26',
    meetupId: 'fxcltsyfcgbhc',
    title: 'Main',
    date: '04/25/23',
    time: '06:00 pm - 07:30 pm MST',
    speaker1: 'Jason Warner',
    description1: 'Reactivity or Why State Management Matters',
    speaker2: 'Zack DeRose',
    description2: 'Amplifying Remote Teams',
    speaker3: 'Joshua Morony',
    description3: 'Thinking Reactively in Angular',
    series: 'americas-en',
  },
  {
    id: 'Mock-27',
    meetupId: '292661005',
    title: 'Main',
    date: '05/09/23',
    time: '11:00 am - 12:30 pm MDT',
    speaker1: 'Israel Guzmán (Izzy)',
    description1: 'NgRx Component Store',
    speaker2: 'Luis Aviles',
    description2: 'TBD',
    series: 'americas-en',
  },
  {
    id: 'Mock-28',
    meetupId: 'fxcltsyfchbfc',
    youtubeId: 'gA6iJbA9oBg',
    title: 'Main',
    date: '05/23/23',
    time: '06:00 pm - 07:30 pm MDT',
    speaker1: 'Chau Tran',
    description1: 'Cracking the Angular Custom Renderer',
    speaker2: 'Markus Ingvarsson',
    description2: 'The Puppet Masters Guide to Injection Tokens',
    speaker3: 'Martina Kraus',
    description3: 'TBD',
    speaker4: 'Jay Cooper Bell',
    description4: 'Eliminating chunk loading roundtrips with Universal SSR',
    series: 'americas-en',
  },
  {
    id: 'Mock-29',
    meetupId: 'fxcltsyfcjbkc',
    title: 'Main',
    date: '06/13/23',
    time: '07:00 pm - 09:00 pm MDT',
    speaker1: 'LIGHTNING TALKS LOLLAPALOOZA',
    description1: 'Little America Hotel - Idaho Room',
    speaker2: '',
    description2:
      'The Lightning Talks Lollapalooza will be a fun-filled night of electrifying 5-minute presentations all about Angular. Come join the party for an opportunity to level-up your skills and connect with fellow Angular developers. You never know who might just show up!',
    speaker3: '',
    description3:
      'ALL are welcome and admission is free, regardless of whether or not you have a ticket to ng-conf. We’ll be in the Idaho Room at the Little America Hotel in Downtown SLC.',
    series: 'americas-en',
  },
  {
    id: 'Mock-30',
    meetupId: '293572521',
    youtubeId: 'gbwPoyxOw1c',
    title: 'Main',
    date: '07/25/23',
    time: '11:00 am - 12:30 pm MDT',
    speaker1: 'WOMEN OF ANGULAR',
    description1: '',
    speaker2: 'Martina Kraus',
    description2:
      'Angular Signals vs. RxJS Observables: A Look at Event Handling and Asynchronous Data Streams',
    speaker3:
      'Jessica Janiuk | Madleina Scheidegger | Tracy Lee | Brooke Avery | Aileen Villanueva | Mini Bhati',
    description3: 'Women of Angular Discussion Panel',
    speaker4: 'Maria Korneeva',
    description4: 'What Do Great Women in IT & Angular Have in Common?',
    series: 'americas-en',
  },
  {
    id: 'Mock-31',
    meetupId: '292661027',
    youtubeId: 'ls7Q2tcvFOw',
    title: 'Main',
    date: '08/08/23',
    time: '5:00 pm - 6:30 pm MDT',
    speaker1: 'Leifer Mendez',
    description1: 'Claves para dominar Qwik',
    speaker2: 'Jimy Dolores',
    description2: 'No todo es Standalone Components',
    speaker3: 'Leti Solis',
    description3: 'Resiliencia en tiempos de cambio',
    series: 'americas-en',
  },
  {
    id: 'Mock-32',
    meetupId: '294766273',
    youtubeId: 'Ptue-lgwwVU',
    title: 'Main',
    date: '08/15/23',
    time: '6:00 pm - 7:00 pm MDT',
    speaker1: 'Hour of EmpoweriNG: A Solutions Space for the Women of Angular',
    description1:
      'Open to ALL developers, the Hour of EmpoweriNG is meant to be a place for providing inspiration, support, mentorship, networking, & SOLUTIONS for women in software engineering.',
    speaker2: 'Kate Sky & Alisa Duncan',
    description2: 'Discussion Panel',
    speaker3: 'Taam Nguyen',
    description3: 'Angular Directives Can Do More Than You Think',
    series: 'americas-en',
  },
  {
    id: 'Mock-33',
    meetupId: '293698736',
    youtubeId: 'zoTRoFBRln4',
    title: 'Main',
    date: '08/22/23',
    time: '6:00 pm - 7:30 pm MDT',
    speaker1: 'Joe Skeen',
    description1: 'Fallin In LOVE with Unit Testing',
    speaker2: 'Dan Wahlin',
    description2: 'Communicate, Communicate, Communicate',
    speaker3: 'Tony Alicea',
    description3: 'Authoring HTML in a JavaScript World',
    series: 'americas-en',
  },
  {
    id: 'Mock-34',
    meetupId: '292661036',
    title: 'Main',
    date: '09/12/23',
    time: '5:00 pm - 6:30 pm MDT',
    speaker1: 'Freddy Montes',
    description1: 'Un Tour por las Novedades en la Web',
    speaker2: 'Sebastian Villalobos',
    description2: 'RPA y Generative AI',
    speaker3: 'Rafael Mestre',
    description3:
      'Mantén un DOM limpio maximizando el uso de los host elements en Angular',
    series: 'americas-en',
  },
  {
    id: 'Mock-35',
    meetupId: '293772582',
    youtubeId: 'Gg4qPvqm2ec',
    title: 'Main',
    date: '09/26/23',
    time: '6:00 pm - 7:30 pm MDT',
    speaker1: 'Eduardo Roth',
    description1: '⚡ Lightning Talk - Signals ⚡',
    speaker2: 'Giovanni Rivas',
    description2:
      '⚡ Lightning Talk - Agile Angular Development with Feature Flags ⚡',
    speaker3: 'Alain Chautard',
    description3: 'Getting Started with State Management',
    series: 'americas-en',
  },
  {
    id: 'Mock-36',
    meetupId: '292661041',
    title: 'Main',
    date: '10/10/23',
    time: '12:00 pm - 2:00 pm CST',
    speaker1: 'Alan Buscaglia',
    description1: 'Descomprimiendo Signals',
    speaker2: 'Rolando Quintero',
    description2: 'Desatando el Genio Silencioso',
    speaker3: 'Sergio Brito',
    description3: 'Data Entity Mapping: Del Diseño al Código',
    series: 'americas-en',
  },
  {
    id: 'Mock-37',
    meetupId: '296350000',
    title: 'Main',
    date: '10/17/23',
    time: '6:00 pm - 7:00 pm MDT',
    speaker1: 'Hour of EmpoweriNG: A Solutions Space for the Women of Angular',
    description1:
      'Open to ALL developers, the Hour of EmpoweriNG is meant to be a place for providing inspiration, support, mentorship, networking, & SOLUTIONS for women in software engineering.',
    speaker2: 'Martine Dowden, Alyssa Nicoll, & Ashley Powell',
    description2: 'Discussion Panel',
    series: 'americas-en',
  },
  {
    id: 'Mock-38',
    meetupId: '296433355',
    title: 'Main',
    date: '10/24/23',
    time: '6:00 pm - 7:30 pm MDT',
    speaker1: 'Alejandro Cuba Ruiz',
    description1: '⚡ The Art of Delaying Image Content ⚡',
    speaker2: 'Justin Schwartzenberger',
    description2: 'Fireside Chat',
    speaker3: 'Michael Hladky',
    description3: 'United by Nxcellent DX',
    series: 'americas-en',
  },
  {
    id: 'Mock-39',
    meetupId: '292661054',
    title: 'Main',
    date: '11/14/23',
    time: '1:00 pm - 2:30 pm CST',
    speaker1: 'Daniel Marin',
    description1:
      '¡De la Billetera al Smartphone: Angular y Solana Reinventando Tus Finanzas!',
    speaker2: 'Derys Dominguez',
    description2: 'Como aprendes Angular con poco conocimientos en código',
    speaker3: 'Abraham Huerta',
    description3:
      'Integración de Websockets en tu aplicacion Angular utilizando Rxjs',
    series: 'americas-en',
  },
  {
    id: 'Mock-40',
    meetupId: '296951753',
    title: 'Main',
    date: '11/28/23',
    time: '6:00 pm - 7:30 pm MDT',
    speaker1: 'Deborah Kurata',
    description1: 'Understanding Git & GitHub',
    speaker2: 'Rafael Mestre',
    description2:
      'Keep A Clean DOM By Maximizing the Use of Host Elements in Angular',
    speaker3: 'Brecht Billiet',
    description3: 'State Management Patterns with Angular Signals',
    series: 'americas-en',
  },
  {
    id: 'Mock-41',
    meetupId: '297978778',
    title: 'Main',
    date: '01/09/24',
    time: '1:00 pm - 2:30 pm CST',
    speaker1: 'Carlos Caballero',
    description1:
      'Web Vitals: 9 Optimizaciones imprescindibles para Desarrolladores',
    speaker2: 'Joan Serna',
    description2: 'Defer en Angular',
    series: 'americas-en',
  },
  {
    id: 'Mock-42',
    meetupId: '298226033',
    title: 'Main',
    date: '1/23/24',
    time: '6:00 pm - 7:30 pm MDT',
    speaker1: 'Ed Ezekiel',
    description1: 'Speaking the Language of Domain Driven Design',
    speaker2: 'Alex Rickabaugh',
    description2: 'Keynote',
    series: 'americas-en',
  },
  {
    id: 'Mock-43',
    meetupId: '298163668',
    title: 'Main',
    date: '2/13/24',
    time: '1:00 pm - 2:30 pm CST',
    speaker1: 'Efisio Pitzalis Morillas',
    description1:
      'Reduce peticiones con resolvers y simplifica la inyección de servicios en Angular',
    speaker2: 'Freddy Montes',
    description2: 'Diseño para developers ',
    series: 'americas-en',
  },
  {
  id: 'Mock-44',
    meetupId: '298940449',
    date: '2/27/24',
    title: 'Main',
    series: 'americas-en',
    time: '6:00 pm - 7:30 pm MDT',
    speaker1: 'Ankita Sood',
    description1: 'Binding Host with Magic of Signals',
    speaker2: 'Daniel Glejzner',
    description2: 'Nx Mental Model',
  },
  {
    id: 'Mock-45',
    date: '3/19/2024',
    title: 'Main',
    series: 'americas-en',
    time: '7:00 pm - 8:00 pm MDT',
    meetupId: '',
    speaker1: 'Lightning Talk Lollapalooza',
    description1: 'LIVE at ng-conf 2024 in Salt Lake City',
    speaker2: '',
    description2: '',
  },
  {
    id: 'Mock-46',
    meetupId: '298421634',
    date: '4/9/2024',
    title: 'Main',
    series: 'americas-en',
    time: '6:00 pm - 7:30 pm CST',
    speaker1: 'Alfredo Perez & Alejandro Cuba Ruiz',
    description1: 'Resolviendo un crucigrama temático sobre Angular',
    speaker2: '',
    description2: '',
  },
  {
    id: 'Mock-47',
    meetupId: '300339938',
    date: '4/23/2024',
    title: 'Main',
    series: 'americas-en',
    time: '6:00 pm - 7:00 pm MDT',
    speaker1: 'Tomasz Ducin',
    description1: 'Ultimate Server-Client State Synchronization with Angular Query',
    speaker2: 'Alfredo Perez',
    description2: 'TanStack Query - The last state management you need',
  },
  {
    id: 'Mock-48',
    meetupId: '298421675',
    date: '5/14/2024',
    title: 'Main',
    series: 'americas-en',
    time: '6:00 pm - 7:30 pm CST',
    speaker1: 'Alfonso Andrés López Molina',
    description1: 'Aplicaciones Angular con Signals',
    speaker2: 'Daniel Ramírez',
    description2: 'Dominando Angular Schematics para Automatización en JS',
  },
  {
    id: 'Mock-49',
    meetupId: '300766126',
    date: '5/28/2024',
    title: 'Main',
    series: 'americas-en',
    time: '6:00 pm - 7:00 pm MDT',
    speaker1: 'Blair Lierman',
    description1: 'My Summer as a Digital Nomad Developer',
    speaker2: 'Doguhan Uluca',
    description2: 'Challenges of Building Enterprise Apps in 2024',
  },
  {
    id: 'Mock-50',
    meetupId: '300736764',
    date: '6/4/2024',
    title: 'Main',
    series: 'americas-en',
    time: '11:00 am - 1:00 pm MDT',
    speaker1: 'Jordan Powell & Tony Alicea',
    description1: 'Mission: Quality - Exploring Code\'s Final Frontier (Week 1 - Testing)',
    speaker2: '',
    description2: '',
  },
  {
    id: 'Mock-51',
    meetupId: '300737178',
    date: '6/11/2024',
    title: 'Main',
    series: 'americas-en',
    time: '11:00 am - 1:00 pm MDT',
    speaker1: 'Michael Dowden & Manfred Steyer',
    description1: 'Mission: Quality - Exploring Code\'s Final Frontier (Week 2 - Code Quality)',
    speaker2: '',
    description2: '',
  },
  {
    id: 'Mock-52',
    meetupId: '300737354',
    date: '6/18/2024',
    title: 'Main',
    series: 'americas-en',
    time: '11:00 am - 1:00 pm MDT',
    speaker1: 'Lara Newsom, Rainer Hahnekamp & Andy Hunt',
    description1: 'Mission: Quality - Exploring Code\'s Final Frontier (Week 3 - Documentation)',
    speaker2: '',
    description2: '',
  },
  {
    id: 'Mock-53',
    meetupId: '300737514',
    date: '6/25/2024',
    title: 'Main',
    series: 'americas-en',
    time: '11:00 am - 1:00 pm MDT',
    speaker1: 'Artem Zakharchenko, Trevor Kendall & Robert "Uncle Bob" Martin',
    description1: 'Mission: Quality - Exploring Code\'s Final Frontier (Week 4 - Testing 2.0)',
    speaker2: '',
    description2: '',
  },
  {
    id: 'Mock-54',
    meetupId: '301203257',
    date: '6/11/2024',
    title: 'Main',
    series: 'americas-en',
    time: '5:00 pm - 6:30 pm CST',
    speaker1: 'Mark Thompson',
    description1: 'Angular 18 AMA',
    speaker2: 'Eduardo Roth',
    description2: 'Angular 18: Saliendo de la Zona',
  },
  {
    id: 'Mock-55',
    meetupId: '301476492',
    date: '6/25/2024',
    title: 'Main',
    series: 'americas-en',
    time: '6:00 pm - 7:00 pm MST',
    speaker1: 'Deborah Kurata',
    description1: 'Angular Renaissance: Block Syntax and Signal Inputs',
    speaker2: 'Tomasz Ducin',
    description2: 'Get rid of Impossible States and make your Angular State Predictable with State Machines'
  },
  {
    id: 'Mock-56',
    meetupId: '301777896',
    date: '7/9/2024',
    title: 'Main',
    series: 'americas-en',
    time: '5:00 pm - 6:30 pm CST',
    speaker1: 'Alvaro Herrero',
    description1: 'Desarrollo de Videojuegos con TypeScript',
    speaker2: 'Nicolas Molina Monroy',
    description2: 'Correr modelos AI directamente desde la Web'
  },
  {
    id: 'Mock-57',
    meetupId: '302026445',
    date: '7/23/2024',
    title: 'Main',
    series: 'americas-en',
    time: '6:00 pm - 7:00 pm MST',
    speaker1: 'Jason Warner',
    description1: 'Making a STATEment in your components',
    speaker2: 'Kate Gable',
    description2: 'Nx monorepo for small projects is like getting a home for a growing family',
    speaker3: 'Bradley Carestia',
    description3: 'Composing Angular Components'
  },
  {
    id: 'Mock-58',
    meetupId: '302522823',
    date: '8/27/2024',
    title: 'August Angular Challenges Mini-Workshop',
    series: 'americas-en',
    time: '6:00 pm - 7:00 pm MST',
    speaker1: 'Eduardo Roth',
    description1: 'Signal Inputs Challenge',
    speaker2: 'Matt Verry',
    description2: 'Pipe Challenge',
    speaker3: 'Bradley Carestia',
    description3: 'RxJS Race Condition Challenge',
  },
  {
    id: 'Mock-59',
    meetupId: '303495524',
    date: '10/10/2024',
    title: 'DevX Days - Week 1',
    series: 'americas-en',
    time: '11:00 am - 12:00 pm MST',
    speaker1: 'Daniel Glassford',
    description1: 'From Model T to rocket launch: How to 10X Your AI Dev Skills in 2025',
    speaker2: 'Alyssa Nicoll, Justin Schwartzenberger, & Mike Brocchi',
    description2: 'Code & Conquer: Mastering Your Developer Experience'
  },
  {
    id: 'Mock-60',
    meetupId: '303495579',
    date: '10/17/2024',
    title: 'DevX Days - Week 2',
    series: 'americas-en',
    time: '11:00 am - 12:30 pm MST',
    speaker1: 'Colum Ferry',
    description1: 'Dont Get Swamped at Work!',
    speaker2: 'Joel Tosi & Dion Stewart',
    description2: 'Learning in the Flow of Work - Your Dojo'
  },
  {
    id: 'Mock-61',
    meetupId: '303495613',
    date: '10/22/2024',
    title: 'DevX Days - Week 3.1',
    series: 'americas-en',
    time: '6:00 pm - 7:00 pm MST',
    speaker1: 'Isabella Johnston',
    description1: 'AI: The Double-Edged Sword - Revolutionizing Performance & Hiring',
    speaker2: 'Ankita Sood',
    description2: 'Sharing is Caring - New & Old Ways of Sharing Data'
  },
  {
    id: 'Mock-62',
    meetupId: '303495613',
    date: '10/24/2024',
    title: 'DevX Days - Week 3.2',
    series: 'americas-en',
    time: '11:00 am - 12:30 pm MST',
    speaker1: 'Chris Pipito',
    description1: 'Software Teaming: Why Would We Work This Way?',
    speaker2: '',
    description2: ''
  },
  {
    id: 'Mock-63',
    meetupId: '303495658',
    date: '10/31/2024',
    title: 'DevX Days - Week 4',
    series: 'americas-en',
    time: '11:00 am - 12:00 pm MST',
    speaker1: 'Craig Spence',
    description1: 'TBD',
    speaker2: 'Shanna Stevens',
    description2: 'Building Bridges: Mastering Conflict Resolution and Empathy in Product + Software Development'
  },
  {
    id: 'Mock-64',
    meetupId: '305856279',
    date: '2/11/2025',
    time: '6:00 pm - 7:00 pm EST',
    title: 'Panel de Expertos sobre Angular Signals',
    series: 'americas-en',
    speaker1: 'Nicolas Molina, Kevin Davila',
    description1: 'Panel de Expertos sobre Angular Signals'
  },
  {
    id: 'Mock-65',
    meetupId: '305785796',
    date: '2/25/2025',
    title: 'Workshop: May the Resource Be With You',
    series: 'americas-en',
    time: '6:00 pm - 7:00 pm MST',
    speaker1: 'Jason Warner',
    description1: 'The Resource API, introduced in Angular 19, offers a declarative and reactive approach to managing asynchronous data operations. This powerful tool simplifies data fetching and state management, making it easier to handle loading, success, and error states in your Angular applications. Come learn how to harness The Force to use this feature to create a more efficient and responsive Star Wars-inspired web experience.'
  },
  {
    id: 'Mock-66',
    meetupId: '307234783',
    date: '4/17/2025',
    title: 'Test Fest | Intro to E2E Testing with Cypress',
    series: 'americas-en',
    time: '11:00 am - 12:00 pm MST',
    speaker1: 'Alain Chautard',
    description1: 'Intro to E2E Testing with Cypress'
  },
  {
    id: 'Mock-67',
    meetupId: '307222658',
    date: '4/21/2025',
    title: 'Test Fest | Angular Unit Tests Distilled',
    series: 'americas-en',
    time: '11:00 am - 12:00 pm MST',
    speaker1: 'Rainer Hahnekamp',
    description1: 'Angular Unit Tests Distilled'
  },
  {
    id: 'Mock-68',
    meetupId: '307222774',
    date: '5/1/2025',
    title: 'Test Fest | Shell-Shocked Testing: Angular Components in Action',
    series: 'americas-en',
    time: '11:00 am - 12:00 pm MST',
    speaker1: 'Rafael Mestre',
    description1: 'Test Fest | Shell-Shocked Testing: Angular Components in Action'
  },
  {
    id: 'Mock-69',
    meetupId: '307518382',
    date: '5/5/2025',
    title: 'Test Fest | Fake It \'til You Mock It',
    series: 'americas-en',
    time: '12:00 pm - 1:00 pm MST',
    speaker1: 'Younes Jaaidi',
    description1: 'Test Fest | Fake It \'til You Mock It'
  },
  {
    id: 'Mock-70',
    meetupId: '307550969',
    date: '5/8/2025',
    title: 'Test Fest | Structuring Code to Avoid Shell-Shocked Testing',
    series: 'americas-en',
    time: '11:00 am - 12:00 pm MST',
    speaker1: 'Jason Warner',
    description1: 'Test Fest | Structuring Code to Avoid Shell-Shocked Testing'
  },
  {
    id: 'Mock-71',
    meetupId: '307613608',
    date: '5/29/2025',
    title: 'Angular 20 Watch Party',
    series: 'americas-en',
    time: '9:45 pm - 10:45 pm MST',
    speaker1: 'Chris Perko, Brooke Avery, Matthew Christiansen',
    description1: 'Angular 20 Watch Party'
  },
  {
    id: 'Mock-72',
    meetupId: '307613725',
    date: '5/29/2025',
    title: 'Angular 20: Fiesta de lanzamiento',
    series: 'americas-en',
    time: '9:45 pm - 10:45 pm MST',
    speaker1: 'Giovanni Rivas, Alejandro Cuba Ruiz, Kensy Ayala',
    description1: 'Angular 20: Fiesta de lanzamiento'
  },
  {
    id: 'Mock-73',
    meetupId: '308469038',
    date: '6/24/2025',
    title: 'Build streaming generative UI with Angular and Hashbrown',
    series: 'americas-en',
    time: '6:00 pm - 7:00 pm MST',
    speaker1: 'Brian Love & Mike Ryan',
    description1: 'Build streaming generative UI with Angular and Hashbrown'
  },
  {
    id: 'Mock-74',
    meetupId: '309408529',
    date: '7/21/2025',
    title: 'Our First In-Person/Hybrid Meetup Since 2020!',
    series: 'americas-en',
    time: '6:00 pm - 7:00 pm MST',
    speaker1: 'Jason Warner',
    description1: '',
    speaker2: 'Brooke Avery & Matthew Christiansen',
    description2: 'AI Pirate Code-Off: Jack Sparrow, Will Turner, and Elizabeth Swann Battle for the AI Waters'
  },
  {
    id: 'Mock-75',
    meetupId: '313372221',
    date: '3/25/2026',
    title: 'Create Your Own AI Workflow',
    series: 'americas-en',
    time: '6:00 pm - 7:00 pm MST',
    speaker1: 'Alfredo Perez',
    description1: 'Ready to stop just "using" AI and start building it into your actual dev cycle? Join us for this month’s Angular Community Meetup where we’re diving into the world of custom AI automation. We’re excited to welcome Angular GDE Alfredo Perez, who’s going to show us how to move past the chat prompt and start building robust, personalized AI workflows. Whether you\'re looking to automate the boring stuff or build smarter features into your apps, you won\'t want to miss out!',
  }
];
